<template>
  <app-page-subsection
    v-if="data.length > 0"
    :title="$t('teacher.page.related_blog_posts_title')"
  >
    <blog-post-card-carousel :list="data" />
  </app-page-subsection>
</template>

<script lang="ts" setup>
import type { TeacherPageView } from "~/business-areas/teacher/teacher.model";

const properties = defineProps<{
  teacher: TeacherPageView;
}>();

const { data } = useLazyAsyncData(
  `teacher_related_blog_posts_${properties.teacher.slug}`,
  async () => {
    if (properties.teacher.courses.length === 0) return [];

    const response = await $fetch(`/api/blog/posts`, {
      query: {
        related_courses: properties.teacher.courses.map((c) => c.slug),
      },
    });

    return response ?? [];
  },
  { default: () => [] },
);
</script>
